<div class="page-container content">
  <h2 class="cald-heading">{{'Admin.Responsive.ScriptVersionDetails' | translate}}</h2>
  @if (model) {
    <div class="full-width script-details">
      <span class="big-text">{{'Admin.Responsive.Version' | translate}}: {{model.versionNumber}}, {{model.changedBy}}
      {{model.created | date:'MM/dd/yy'}}</span>
    </div>
  }
  <div class="full-width">
    <cpq-scripting-codemirror #codeMirror [script]="scriptConfig" [disabled]="true" [hideFooter]='true' [hideProxyGenerationToggle]='true' [languageType]="languageType"></cpq-scripting-codemirror>
  </div>
</div>
